<app-column-manager [inputColumns]="data.columns" [inputDefaultColumns]="data.defaultColumns"
    (columnsChange)="onColumnsChange($event)" (close)="onClose()">
</app-column-manager>